/**
 * Theme Requirements Aggregation for Parkplace Residential
 * 
 * Extends the base landing-page theme requirements with Parkplace Residential specific
 * component requirements.
 */

import type { ComponentRequirements } from '@vibesites/tokens';
import { componentRequirements as baseRequirements } from '@vibesites/theme-landing-page/requirements';

/**
 * Parkplace Residential component requirement overrides.
 * Add requirements for any override components here.
 */
const parkplaceresidentialOverrides: Record<string, ComponentRequirements> = {
  // Example:
  // Footer: FooterRequirements,
};

/**
 * All component requirements for the Parkplace Residential theme.
 * Inherits from landing-page theme and overrides with Parkplace Residential components.
 */
export const componentRequirements: Record<string, ComponentRequirements> = {
  ...baseRequirements,
  ...parkplaceresidentialOverrides,
};

/**
 * Get requirements for a specific component.
 */
export function getComponentRequirements(componentName: string): ComponentRequirements | undefined {
  return componentRequirements[componentName];
}

/**
 * Get all component names that have requirements defined.
 */
export function getRegisteredComponentNames(): string[] {
  return Object.keys(componentRequirements);
}
